import { render, staticRenderFns } from "./adviceBookModel.vue?vue&type=template&id=0d15b038&scoped=true&"
import script from "./adviceBookModel.vue?vue&type=script&lang=js&"
export * from "./adviceBookModel.vue?vue&type=script&lang=js&"
import style0 from "./adviceBookModel.vue?vue&type=style&index=0&id=0d15b038&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d15b038",
  null
  
)

export default component.exports